<template>
  <div class="userInfo_warpper">
    <el-card class="box-card" style="height:100%">
      <div class="userInfo">
        <div class="imgWarpper">
          <el-image
            fit="fill"
            style="width:100%; height:100%;"
            :src="avatar || defaultUserIcon"
          ></el-image>
        </div>
        <div class="userInfo-right">
          <div class="contentWarpper">
            <div class="username">{{ nickname }}</div>
            <div class="position">{{ userInfo.level_dictText }}</div>
            <div class="department">{{ userInfo.userType_dictText }}</div>
          </div>
          <div class="btnWarpper">
            <i class="el-icon-edit-outline" @click="setUserInfo()"></i>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import config from "@/config/config";
const defaultUserIcon = require("../../assets/images/defaultIcon.jpg");
import util from "@/utils";
export default {
  name: "",
  components: {},
  props: {
    userInfo: Object,
  },
  data() {
    return {
      defaultUserIcon: defaultUserIcon,
      nickname: "",
      avatar: "",
    };
  },
  created() {
    this.nickname = JSON.parse(util.getStore("userInfo")).nickname;
    this.avatar = JSON.parse(util.getStore("userInfo")).avatar;
  },
  methods: {
    setUserInfo() {
      this.$router.push({
        path: "/index/user/auditInformation",
      });
      console.log("setUserInfo");
    },
  },
};
</script>

<style lang="scss" scoped>
.userInfo_warpper {
  height: 150px;
}
.userInfo {
  display: flex;
  height: 100%;
  .imgWarpper {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: pink;
    overflow: hidden;
  }
  .userInfo-right {
    flex: 1;
    display: flex;
    .contentWarpper {
      color: #000;
      font-size: 16px;
      flex: 0 0 70%;
      display: flex;
      align-items: flex-start;
      margin-left: 12px;
      flex-direction: column;
      justify-content: space-around;
      .username {
        font-size: 30px;
      }
      .department {
        // color: #2f78ff;
        color: #fc701a;
      }
    }
  }

  .btnWarpper {
    font-size: 40px;
    color: #ccc;
    justify-content: flex-end;
    flex: 0 0 10%;
    cursor: pointer;
  }
}
</style>
